module.exports = __webpack_public_path__ + "static/media/HandsOnWorking-Pottery.7df2297a.mp4";